import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { UserAvatar } from './UserAvatar';
import { AvatarUploadButton } from './AvatarUploadButton';

export const ProfilePhotoCard = ({ user, setUser }) => (
  <Card data-testid="profile-photo-card">
    <CardHeader>
      <CardTitle>Photo de profil</CardTitle>
      <CardDescription>PNG, JPG ou WEBP, 3 Mo maximum. L’image est recadrée en carré. Sans photo, vos initiales s’affichent.</CardDescription>
    </CardHeader>
    <CardContent className="flex items-center gap-6">
      <UserAvatar person={user} size="lg" testId="profile-avatar" />
      <AvatarUploadButton hasPhoto={!!user?.avatar_url} onChange={(url) => setUser?.({ ...user, avatar_url: url })} />
    </CardContent>
  </Card>
);

export default ProfilePhotoCard;
